import {
  Box,
  Card,
  Container,
  Divider,
  Grid,
  Typography,
  Button
} from '@mui/material'
import styled from '@emotion/styled'

function CurrentPlanDialog({ title, initialValues, onChangePlan }) {
  if (initialValues == undefined) initialValues = {}

  const CurrentPlan = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',

    '& > *': {
      margin: theme.spacing(1),
      width: '100%',
      maxWidth: '200px',
      height: theme.spacing(80),
      borderStyle: 'solid',
      borderWidth: '2px',
      borderColor: '#69d9d4',
      backgroundColor: '#c4edec',
    }
  }));

  return (
    <Container >
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h6" gutterBottom display="inline">
            {title}
          </Typography>
        </Grid>
        <Grid item />
      </Grid>

      <CurrentPlan style={{ paddingTop: 5 }} >
        <Card elevation={24} style={{ height: 'auto' }}>
          <Grid
            spacing={1}
            direction="column"
            alignItems="center"
            justifyContent="center"
            container
          >
            <Divider my={1} />
            <Grid item sx={{ mt: 3 }}>
              <Typography variant="h5" style={{ color: '#065656' }}>
                {initialValues?.current_plan?.name}
              </Typography>
            </Grid>

            <Grid item sx={{ mt: 5 }}>
              <Typography variant="h6" style={{ fontSize: 14, color: '#065656' }}>
                {initialValues?.current_plan?.application?.application_name}
              </Typography>
            </Grid>
            <Grid item style={{ paddingTop: 10 }}>
              <Grid container alignItems="center" direction="column">
                <Typography style={{ fontSize: 12, color: '#065656' }}>
                  Active Users &#8194;
                </Typography>
                <Typography
                  style={{
                    fontSize: 22,
                    fontWeight: 'bold',
                    color: '#065656',
                  }}
                >
                  {initialValues?.current_users}
                </Typography>
              </Grid>
            </Grid>
            {/* <Grid item style={{ paddingTop: 10 }}>
              <Grid container alignItems="center" direction="column">
                <Typography style={{ fontSize: 12, color: '#065656' }}>
                  Allowed Users &#8194;
                </Typography>
                <Typography
                  style={{
                    fontSize: 22,
                    fontWeight: 'bold',
                    color: '#065656',
                  }}
                >
                  {initialValues?.max_users}
                </Typography>
              </Grid>
            </Grid> */}

            <Grid item style={{ paddingTop: 10 }}>
              <Typography sx={{
                fontSize: 18,
                fontWeight: 'bold', color: (initialValues?.active == 'Active') ? "green" : ((initialValues?.active == 'Inactive') ? "red" : "black")
              }}>
                {initialValues?.active}
              </Typography>

            </Grid>
          </Grid>

          <Grid style={{ paddingTop: 20 }} direction="column" justifyContent="center" alignItems="center" container >
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={onChangePlan}
            >
              Change Plan
            </Button>
          </Grid>
          <Box height={15} />
        </Card>
      </CurrentPlan>
    </Container>
  );
}

export default CurrentPlanDialog
